import React from "react";
import graphql from "babel-plugin-relay/macro";
import { QueryRenderer } from "react-relay";

import NavDrawer from "./NavDrawer";
import Loader from "../Loader";
import withTheme from "themes/app_theme";

const NavDrawerContainer = withTheme(NavDrawer);

const Changer = ({ classes, initialIDValue, ...other }) => {
  return (
    <QueryRenderer
      environment={
        other.environment || (other.relay && other.relay.environment)
      }
      query={graphql`
        query NavDrawerQuery($id: String) {
          authorizedSuborgs(orgId: "any", first: 1, propertyId: $id) {
            id
            name
            region
            timezone
            timezoneOffset
            propertyLogoUrl
            propertyManagerLogoUrl
            timezone
            linkColor
            fontFamily
            textColor
            buttonBorderColor
            buttonFontColor
            buttonBackgroundColor
            org {
              id
              name
            }
          }
        }
      `}
      variables={{
        id: initialIDValue
      }}
      render={({ error, props }) => {
        if (Boolean(error)) {
          return <div>{error.message}</div>;
        } else if (props) {
          return (
            <NavDrawerContainer
              {...other}
              initialValue={props.authorizedSuborgs[0]}
              initialIDValue={initialIDValue}
            />
          );
        } else {
          return <Loader />;
        }
      }}
    />
  );
};

export default React.memo(Changer);
